import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core'
import { FormGroup } from '@angular/forms'
import * as CategoriesActions from 'libs/gb-dashboard/item/data-access-categories/src/lib/+state/categories.actions'
import { CategoriesFacade } from 'libs/gb-dashboard/item/data-access-categories/src/lib/+state/categories.facade'
import { GbEditCategoryComponent } from '../gb-edit-category/gb-edit-category.component'
@Component({
  selector: 'gb-create-category-dialog',
  templateUrl: './gb-create-category-dialog.component.html',
  styleUrls: ['./gb-create-category-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbCreateCategoryDialogComponent {
  selectedItems: string[] = []
  editCreateLoaded$ = this.categoriesFacade.editCreateLoaded$

  @ViewChild('editCategoryComponent')
  editCategoryComponent!: GbEditCategoryComponent

  createCategoryForm!: FormGroup

  markFormAsTouched = 0

  constructor(private categoriesFacade: CategoriesFacade) {}

  ngAfterViewInit(): void {
    this.createCategoryForm = this.editCategoryComponent.categoryForm
  }

  selectItems(items: string[]) {
    this.selectedItems = items
  }

  submit() {
    this.createCategoryForm.valid ? this.createCategory() : this.markAsTouched()
  }

  markAsTouched() {
    this.markFormAsTouched++
  }

  createCategory() {
    this.categoriesFacade.dispatch(
      CategoriesActions.createCategory({
        label: this.createCategoryForm.value.label,
        items: this.selectedItems,
      }),
    )
  }
}
